import { render } from "./PageDDLMgmt.vue?vue&type=template&id=1482f8f3&ts=true"
import script from "./PageDDLMgmt.vue?vue&type=script&lang=ts"
export * from "./PageDDLMgmt.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__